import React, { useEffect, useState } from "react";
import { SemanticChart, ChartData } from "../shared/SemanticChart";
import { TestSetService } from "../../services/TestSetService";

interface TestSetSemanticChartProps {
  testSetId: string;
  apiKey: string;
  isExpanded: boolean;
}

export const TestSetSemanticChart: React.FC<TestSetSemanticChartProps> = ({
  testSetId,
  apiKey,
  isExpanded
}) => {
  const [chartData, setChartData] = useState<ChartData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (testSetId) {
      fetchChart();
    }
  }, [testSetId, apiKey]);

  const fetchChart = async () => {
    try {
      setLoading(true);
      setError(null);
      
      TestSetService.getSemanticChart(
        testSetId,
        setLoading,
        apiKey,
      ).subscribe(
        (data: ChartData) => {
          setChartData(data);
          setLoading(false);
        },
        (error: any) => {
          console.error("Error fetching semantic chart:", error);
          setError(error.message || "Failed to load semantic chart");
          setLoading(false);
        }
      );
    } catch (err) {
      console.error("Error in semantic chart component:", err);
      setError(err instanceof Error ? err.message : "An error occurred");
      setLoading(false);
    }
  };
  
  return isExpanded ? (
    <SemanticChart
      data={chartData}
      loading={loading}
      error={error}
    />
  ) : null;
}; 